var _defs, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyFavorites = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "EmptyFavorites_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "111.07 176.22 857.86 727.57"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".EmptyFavorites_svg__cls-1{stroke-width:3px}.EmptyFavorites_svg__cls-1,.EmptyFavorites_svg__cls-2,.EmptyFavorites_svg__cls-4,.EmptyFavorites_svg__cls-6{stroke:#000;stroke-miterlimit:10}.EmptyFavorites_svg__cls-1,.EmptyFavorites_svg__cls-6{fill:none}.EmptyFavorites_svg__cls-2{fill:#fff}.EmptyFavorites_svg__cls-4{fill:#ef255a}.EmptyFavorites_svg__cls-6{stroke-width:2.38px}.EmptyFavorites_svg__cls-9{stroke-width:0;fill:#00e8ab}"))), /*#__PURE__*/React.createElement("path", {
  d: "M964.69 684.4c-4.94 13.49-14.63 23.54-27.25 30.74-23.61 13.47-49.49 16.63-75.95 17.11-19.26.35-38.52.44-57.66 3.14-14.31 2.01-27.88 6.2-39.87 14.26-11.89 7.98-21.28 18.17-23.56 33.15-1.28 8.43-.31 16.87.43 25.26 2.25 25.22-7.74 45.21-26.14 61.57-19.81 17.62-43.4 27-69.25 31.43-34.98 6.01-68.93 1.93-101.87-10.7-25.93-9.94-48.92-24.67-68.56-44.39-9.84-9.87-18.99-20.43-29.33-29.82-9.18-8.34-19.15-15.25-31.49-18.18-14.44-3.43-27.96-.49-41.11 5.55-11.29 5.18-21.73 11.84-32.28 18.31-12.49 7.66-25.13 14.99-39.26 19.26-16.3 4.94-32.37 3.31-48.22-2.02-18.66-6.27-35.91-15.3-51.32-27.57-18.19-14.46-21.38-36.69-9.08-56.53 9.81-15.84 24.27-26.11 39.87-35.18 22.46-13.05 47.34-20.39 71.28-29.96 7.69-3.07 15.55-5.77 22.38-10.74 10.55-7.67 11.47-16.67 2.27-25.79-9.99-9.9-22.13-14.98-36.12-15.84-10.4-.64-20.87-.24-31.19-1.87-10.93-1.73-20.93-5.54-27.9-14.81-6.17-8.2-6.89-17.34-3.51-26.67 6.6-18.16 20.66-27.3 38.91-30.92 1.17-.23 2.34-.44 3.51-.63 9.32 8.2 19.87 15.3 31.53 21.01l245.14 119.97c4.48 2.19 9.42 3.35 14.37 3.37.34 0 .68 0 1.03-.01 5.95-.1 13.91-1.13 18.77-4.08h.02c4.5-2.3 8.46-5.65 11.49-9.75l128.97-174.1c8.31.21 16.63 1.1 24.94 2.8 16.02 3.28 30.76 9.54 42.01 22.05a89.015 89.015 0 0 1 12.82 18.52c9.35 18.01 23.98 26.99 44.13 27.56 13.86.39 27.72-1.23 41.55-.16 23.96 1.85 45.71 9.51 61.83 28.01 16.87 19.35 22.73 41.92 13.67 66.66Z",
  style: {
    strokeWidth: 0,
    fill: "#2fd1a2"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "EmptyFavorites_svg__cls-4",
  d: "M757.34 473.22 594.88 692.53c-3.24 4.37-7.53 7.9-12.42 10.21l8.58-40.96c.38-1.78-.02-3.62-1.08-5.08l-40.29-55.41 32.64-69.3c1.02-2.18.73-4.76-.74-6.66l-51.53-66.24 38.48-75.63c1.11-2.18.88-4.78-.58-6.74l-39.87-53.37c-2.22-2.98-2.1-7.11.3-10.28 0-.03.1-.13.11-.16 16.92-22.83 39.34-40.88 64.86-52.2 46.18-20.5 96.33-16.02 134.13 11.98 63.52 47.06 76.91 137.01 29.86 200.53Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "EmptyFavorites_svg__cls-4",
  d: "M570.16 705.74c-1.54.31-3.11.51-4.68.58-5.58.3-11.22-.85-16.27-3.32L304.07 583.02c-71-34.76-100.5-120.79-65.75-191.79 20.86-42.62 63.72-69.69 114.65-72.42 27.51-1.47 55.38 4.26 80.54 16.58.02.01.1.05.13.06 9.47 4.55 16.96 9.44 22.91 14.96l41.52 38.42-24.14 81.45c-.71 2.38.02 4.96 1.88 6.61l62.78 55.87-19.5 73.94c-.6 2.26.08 4.66 1.78 6.27l50.36 47.84-1.07 44.92Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m591.88 579.6-132.17-33.03c-17.37-4.34-28.18-20.98-24.14-37.16l.09-.38c4.04-16.18 21.41-25.78 38.78-21.44l132.17 33.03c17.37 4.34 28.18 20.98 24.14 37.16l-.09.38c-4.04 16.18-21.41 25.78-38.78 21.44Z",
  style: {
    strokeWidth: 0,
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#eadca4",
    stroke: "#000",
    strokeMiterlimit: 10
  },
  d: "m499.45 493.1-13.81 60.72 76.34 18.32 15.27-58.85-77.8-20.19z"
}), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 517.33,
  cy: 514.48,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 517.276 514.467)"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 535.41,
  cy: 518.96,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 535.335 518.913)"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 553.5,
  cy: 523.43,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 553.51 523.43)"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 513.79,
  cy: 528.76,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 513.865 528.807)"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 531.88,
  cy: 533.24,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 531.924 533.254)"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 549.97,
  cy: 537.71,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 549.995 537.723)"
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 510.26,
  cy: 543.04,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 510.351 543.1)"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 528.35,
  cy: 547.52,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 528.343 547.508)"
})), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
  className: "EmptyFavorites_svg__cls-2",
  cx: 546.44,
  cy: 551.99,
  rx: 4.93,
  ry: 4.85,
  transform: "rotate(-31.11 546.402 551.954)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m591.45 579.49-131.79-32.93c-17.33-4.33-28.09-20.96-24.05-37.14l.09-.38c4.04-16.18 21.37-25.79 38.69-21.46l131.79 32.93c17.33 4.33 28.09 20.96 24.05 37.14l-.09.38c-4.04 16.18-21.37 25.79-38.69 21.46Z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "EmptyFavorites_svg__cls-9",
  d: "M369.57 176.22c3.27 28.9 7.23 33.45 35.39 40.69-28.9 3.27-33.45 7.23-40.69 35.39-3.27-28.9-7.23-33.45-35.39-40.69 28.9-3.27 33.45-7.23 40.69-35.39ZM477.22 252.3c9.56 16.44 13.13 18.13 31.89 15.05-16.44 9.56-18.13 13.13-15.05 31.89-9.56-16.44-13.13-18.13-31.89-15.05 16.44-9.56 18.13-13.13 15.05-31.89ZM577.38 180.5c-1.27 18.98.74 22.37 18.02 30.32-18.98-1.27-22.37.74-30.32 18.02 1.27-18.98-.74-22.37-18.02-30.32 18.98 1.27 22.37-.74 30.32-18.02Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "EmptyFavorites_svg__cls-1",
  d: "M235.01 366.54c-9.6 1.67-18.74-4.76-20.41-14.36-1.67-9.61-10.81-16.04-20.41-14.37s-18.74-4.76-20.41-14.36M261.15 323.76c-7.97-5.61-9.89-16.62-4.28-24.59 5.61-7.98 3.69-18.99-4.28-24.59-7.97-5.61-9.89-16.62-4.28-24.59M186.34 405.05c-5.61 7.97-16.62 9.89-24.59 4.28-7.97-5.61-18.98-3.69-24.59 4.28-5.61 7.97-16.62 9.89-24.59 4.28"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "EmptyFavorites_svg__cls-6",
  d: "M793.74 396.82c6.09-4.82 16.91-5.44 24.16-1.39 7.25 4.05 18.07 3.42 24.16-1.39 6.09-4.82 16.91-5.44 24.16-1.39M801.08 428.8c9.44-.54 17.75 4.09 18.57 10.36.82 6.27 9.13 10.91 18.57 10.36 9.44-.54 17.75 4.09 18.57 10.36M805.83 357.58c-.82-6.27 6.17-11.79 15.6-12.33 9.44-.54 16.42-6.06 15.6-12.33-.82-6.27 6.17-11.79 15.6-12.33"
})));
export default SvgEmptyFavorites;